import styled from 'styled-components';
import Button from './index';

const ClearButton = styled(Button)`
  background-color: ${props => props.theme.color.linkPrimary};
  border-color: ${props => props.disabled ? props.theme.color.borderPrimaryFaded : props.theme.color.borderPrimary};
  color: ${props => props.disabled ? props.theme.color.headerSecondaryFaded : props.theme.color.headerSecondary};
  &:hover {
    background-color: ${props => props.disabled ? props.theme.color.linkPrimary : props.theme.color.linkPrimaryDarkened};
    border-color: ${props => props.disabled ? props.theme.color.borderPrimaryFaded : props.theme.color.borderPrimaryDarkened};
    color: ${props => props.disabled ? props.theme.color.headerSecondaryFaded : props.theme.color.headerSecondaryDarkened};
  }
`;

export default ClearButton;
